export function goToSection(section: number) {
  document.querySelectorAll('.section')[section].scrollIntoView({
    behavior: 'smooth',
    block: 'start',
  });
}

export default { goToSection };
